import parse from 'html-react-parser';

export default function TableCsv(props) {
  const { titleText, tabledata, heads, footerText } = props;
  const mheads = Array.isArray(heads[0]) ? heads : [ heads ];

  return (
  	<div style={{ fontSize:"80%" }}>
        <p>{parse(titleText)}</p>
        {mheads.map((hrow, r) => {
            return (
                <div key={r}>
                    {hrow.map((th, c) => {
                        if (!th.invisible) { 
                            return  <span key={th.id+c}>{th.text}, </span>
                        }
                    })}
                </div>
            )
        })}
        {tabledata.map((trow, r) => {
            return (
                <div key={r} >
                    {mheads[0].map((hc) => {
                        if (!hc.invisible && hc.id !== null) {
                            return <span key={hc.id+r}>{trow[hc.id].toLocaleString("en")}, </span>
                        }
                    })}
                </div>
            )
        })}
        <p>{parse(footerText)}</p>
  	</div>
  )
}